import React, { Component } from 'react'
import styled from 'styled-components'
import translate from '../../../../modules/translate/index'
import ContainerAd from '../../../../components/ContainerAd/index'
import Title from '../../../../components/Title/index'
import LoginForm, {
  StyledCheckBox0LoginForm,
  StyledConfirmationText0LoginForm,
  StyledErrorText0LoginForm,
  StyledHelpButton0LoginForm,
  StyledInputDropZone0LoginForm,
  StyledText0LoginForm,
  StyledTitle0LoginForm,
} from '../../components/LoginForm/index'
import Text from '../../../../components/Text/index'
import { Redirect, withRouter } from 'react-router'
import { generatePathByRouteName, namedRoute } from '../../../../modules/named-router/index'
import { getStoredItem, clearStoredItem } from '../../../../modules/stored-item'
import isStolApp from '../../../../modules/is-stolapp/index'
import { automaticLogin } from '../../../../modules/login'
import NavLink from '../../../../components/NavLink'
import Button from '../../../../components/Button'
import isServerSide from '../../../../modules/is-server-side'

const StyledContainerAd = styled(ContainerAd)`
  padding-bottom: 1em;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    > div > div {
      display: flex;
      min-height: 120px;
      align-items: center;
    }
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`

const Wrapper = styled.div`
  margin-left: ${(props) => props.theme.sizes.gapEdge};
  margin-right: ${(props) => props.theme.sizes.gapEdge};
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  display: flex;
  flex-direction: row-reverse;
  position: relative;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-left: ${(props) => props.theme.tablet.sizes.gapEdge};
    margin-right: ${(props) => props.theme.tablet.sizes.gapEdge};
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    &:before {
      position: absolute;
      top: -2em;
      left: 0;
      right: 0;
      bottom: 0;
      min-height: 2em;
      min-width: 100%;
      content: '';
      background-color: ${(props) => props.theme.color.multimedia.backgroundSecondary};
    }
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-left: ${(props) => props.theme.mobile.sizes.gapEdge};
    margin-right: ${(props) => props.theme.mobile.sizes.gapEdge};
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    margin-top: 0;
    &:before {
      position: absolute;
      top: -2em;
      left: 0;
      right: 0;
      bottom: 0;
      min-height: 2em;
      min-width: 100%;
      content: '';
      background-color: ${(props) => props.theme.color.multimedia.backgroundSecondary};
    }
  }
  @media (max-width: 778px) {
    margin-top: 0;
    &:before {
      top: 0;
    }
  }
`

const DescriptionWrapper = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.color.multimedia.backgroundSecondary};
  z-index: 0;
  min-width: cacl(100% - 2em);
  min-height: 16em;
  max-height: 16em;
  left: 0;
  bottom: ${(props) => props.theme.sizes.gapVertical};
  right: 0;
  top: ${(props) => props.theme.sizes.gapVertical};
  padding-left: 2em;
  padding-top: 2em;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
    top: ${(props) => props.theme.tablet.sizes.gapVertical};
    position: relative;
    margin: 0;
    margin-top: -2em;
    padding-top: 2em;
    padding-right: 2em;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
    top: ${(props) => props.theme.mobile.sizes.gapVertical};
    min-height: auto;
    padding-bottom: 2em;
  }
`

const StyledTitle = styled(Title)`
  color: white;
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.titleBigger};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.titleBigger};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.titleBigger};
  }
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.textInverted};
  max-width: ${(props) => props.theme.sizes.col6};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    max-width: none;
    font-size: ${(props) => props.theme.fontSize.title1};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    max-width: none;
    font-size: ${(props) => props.theme.mobile.fontSize.title3};
  }
`

const StyledLoginForm = styled(LoginForm)`
  margin-right: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-right: ${(props) => props.theme.tablet.sizes.gapVertical};
    margin-left: ${(props) => props.theme.tablet.sizes.gapVertical};
    min-width: none;
    ${StyledTitle0LoginForm} {
      max-width: none;
    }
    ${StyledCheckBox0LoginForm} {
      max-width: none;
      align-items: center;
    }
    ${StyledHelpButton0LoginForm} {
      width: calc(100% -45px - 4px);
      margin-top: 1em;
    }
  }
  min-width: 330px;
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-right: 0px;
    margin-left: 0px;
    min-width: 0;
    ${StyledTitle0LoginForm} {
      max-width: none;
    }
    ${StyledCheckBox0LoginForm} {
      max-width: none;
      align-items: center;
    }
    ${StyledHelpButton0LoginForm} {
      width: calc(100% -45px - 4px);
      margin-top: 1em;
    }
  }
  z-index: 1;
  ${StyledHelpButton0LoginForm} {
    width: calc(100% - 48px - 4px);
    margin-top: 1em;
  }
  ${StyledTitle0LoginForm} {
    max-width: 13.5em;
    margin: 0 auto;
    margin-top: 0.5em;
    margin-bottom: 0.8em;
  }
  ${StyledInputDropZone0LoginForm} {
    max-width: 20em;
    margin: 0 auto;
  }
  ${StyledCheckBox0LoginForm} {
    max-width: 20em;
    padding-bottom: 1em;
    text-align: left;
    display: flex;
    align-items: start;
  }
  ${StyledText0LoginForm} {
    max-width: 18em;
    display: flex;
  }
  ${StyledErrorText0LoginForm} {
    max-width: 18em;
    display: flex;
  }
  ${StyledConfirmationText0LoginForm} {
    max-width: 18em;
    display: flex;
  }
  @media ((max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) and (min-width: ${(props) =>
      props.theme.mobile.breakPoint + 'px'})) {
    margin: 0 auto;
    width: calc(100% - (2 * ${(props) => props.theme.tablet.sizes.gapEdge}));
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    width: auto;
    margin-right: 0;
    ${StyledCheckBox0LoginForm} {
      align-items: start;
    }
  }
`

const ButtonWrapper = styled.div`
  margin-top: 15px;
`

let windowMatch = undefined

if (!isServerSide()) {
  windowMatch = {
    path: window.location.pathname,
    params: {
      registerPart:
        generatePathByRouteName('register.verification', '/').split('/')[1] ===
          window.location.pathname.split('/')[1] &&
        (window.location.pathname.split('/')[2] !== undefined || window.location.pathname.split('/')[2] !== '')
          ? window.location.pathname.split('/')[2]
          : undefined,
      resetToken:
        generatePathByRouteName('resetPassword', '/').split('/')[1] === window.location.pathname.split('/')[1] &&
        generatePathByRouteName('resetPassword', '/').split('/')[2] === window.location.pathname.split('/')[2] &&
        (window.location.pathname.split('/')[3] !== undefined || window.location.pathname.split('/')[3] !== '')
          ? window.location.pathname.split('/')[3]
          : undefined,
      verificationToken:
        generatePathByRouteName('register.verification', '/').split('/')[1] ===
          window.location.pathname.split('/')[1] &&
        (window.location.pathname.split('/')[2] !== undefined || window.location.pathname.split('/')[2] !== '') &&
        (window.location.pathname.split('/')[3] !== undefined || window.location.pathname.split('/')[3] !== '')
          ? window.location.pathname.split('/')[3]
          : undefined,
    },
  }
}

class LoginRegisterAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirectBack: false,
      loginMessage:
        this.props.location && this.props.location.state && this.props.location.state.loginMessage
          ? this.props.location.state.loginMessage
          : undefined,
      match:
        this.props.match.path === '/' && !isServerSide() && windowMatch !== undefined ? windowMatch : this.props.match,
    }
    this.callBackAfterLogin = this.callBackAfterLogin.bind(this)
    this.callBackAfterLogout = this.callBackAfterLogout.bind(this)
  }
  callBackAfterLogin() {
    if (getStoredItem('login_redirect') !== null) {
      if (!isServerSide()) {
        if (window && window.location) {
          window.location.replace(getStoredItem('login_redirect'))
          clearStoredItem('login_redirect')
        }
      }
    }
    this.forceUpdate()
    if (this.props.location && this.props.location.state && this.props.location.state.prevPathName) {
      this.setState({
        redirectBack: true,
      })
    }
  }
  callBackAfterLogout() {
    this.forceUpdate()
  }
  /*
  callBackAfterRegistration(){

  }
  */
  componentDidMount() {
    automaticLogin()
    if (
      this.state.match.path ===
      '/' +
        namedRoute('register.verification').path.match(/[^/]*/g)[1] +
        '/' +
        namedRoute('register.verification').path.match(/[^/]*/g)[3]
    ) {
      if (this.state.match.params && this.state.match.params.registerPart === 'verify-invalid') {
        this.setState({
          loginMessage: translate('login_verify_token_invalid_message'),
        })
      }
    }
    if (
      this.state.match.path ===
      '/' +
        namedRoute('register.verification').path.match(/[^/]*/g)[1] +
        '/' +
        namedRoute('register.verification').path.match(/[^/]*/g)[3] +
        '/' +
        namedRoute('register.verification').path.match(/[^/]*/g)[5]
    ) {
      if (this.state.match.params && this.state.match.params.verificationToken) {
        this.setState({
          loginMessage: translate('login_verify_token_message'),
        })
      }
    }
  }
  render() {
    const { ...props } = this.props
    return (
      <React.Fragment>
        {!isStolApp() && (
          <Wrapper {...props}>
            <StyledLoginForm
              callBackAfterLogin={this.callBackAfterLogin}
              callBackAfterLogout={this.callBackAfterLogout}
              loginMessage={this.state.loginMessage}
              _match={this.state.match}
            />
            <DescriptionWrapper>
              <StyledTitle>{translate('login_my_stol')}</StyledTitle>
              <StyledText>{translate('login_my_stol_description')}</StyledText>
              <ButtonWrapper>
                <Button to={namedRoute('userGeneratedContent').path} view="inverted">
                  {translate('ugc')}
                </Button>
              </ButtonWrapper>
            </DescriptionWrapper>
          </Wrapper>
        )}
        <StyledContainerAd adIds={['S3', 'S4']} />
        {this.state.redirectBack && (
          <Redirect
            to={{ pathname: this.props.location.state.prevPathName, state: { data: this.props.location.state.data } }}
          />
        )}
      </React.Fragment>
    )
  }
}

export default withRouter(LoginRegisterAccount)
